import { debounce } from '@mui/material'

export const sumOf = (array: number[]): number => {
  return array.reduce((accumulator, currentValue) => {
    return accumulator + currentValue
  }, 0)
}

export const withDebounce = (callback: any, time: number = 100) => {
  // Use the debounce utility from Material-UI
  const debouncedCallback = debounce(callback, time)

  // Return a function that will execute the debounced callback
  return (...args: any) => {
    debouncedCallback(...args)
  }
}

export const isEmail = (email: string | undefined): boolean => {
  if (email === undefined) {
    return false
  }

  // Regular expression for a basic email validation
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
  return emailRegex.test(email)
}

export function removeDuplicates<T>(arr: T[]): T[] {
  return Array.from(new Set(arr))
}
